import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '@clooper/core';
import { FlightService } from '@clooper/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resend-flight-receipt',
  templateUrl: './resend-flight-receipt.component.html',
  styleUrls: ['./resend-flight-receipt.component.scss']
})
export class ResendFlightReceiptComponent implements OnInit {

  requestSent = false;
  icons = {
    cancel: faTimes
  }
  id: any;
  loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private booking: FlightService,
    private router: ActivatedRoute,
    public options: ModalOptions,
    private gs: GeneralService,
    private toastr: ToastrService,


  ) { 

    this.id = this.options?.initialState?.id
  }

  ngOnInit(): void {
    
  }



  resend() {
    this.loading = true;

    this.booking.resendFlightBookingConfirmation(this.id).subscribe((res: any) => {
      this.loading = false
      if (res) {

        this.requestSent = true;
      }
    }, err => {
      this.toastr.error(this.gs.getErrMsg(err));

    })
    }

}
